import React from "react";
import { SummaryContainer, SummaryItem, SummaryTotal } from "./styles";

const PurchaseSummary = ({ itens }) => {
    const total = itens.reduce((acc, item) => acc + item.unit_amount * item.quantity, 0);

    return (
        <SummaryContainer>
            <h4>Resumo da Compra</h4>
            {itens.map((item) => (
                <SummaryItem key={item.id}>
                    <span>{item.product.name}</span>
                    <span>
                        {item.quantity} x R$ {(item.unit_amount / 100).toFixed(2)}
                    </span>
                </SummaryItem>
            ))}
            <SummaryTotal>
                <strong>Total:</strong>
                <span>R$ {(total / 100).toFixed(2)}</span>
            </SummaryTotal>
        </SummaryContainer>
    );
};

export default PurchaseSummary;
